<div class="page-content page-fill">
    <h1 class="mb-4">Welcome to {{ church }}</h1>
    <form (submit)="login()" class="col-6" style="max-width: 400px;" (keydown.enter)="login()" >
        <dx-form [(formData)]="model" [labelLocation]="'left'" [showColonAfterLabel]="false" validationGroup="loginData" showValidationSummary="true" [showRequiredMark]="false">
            <dxi-item itemType="group">
                <dxi-item dataField="userName" [isRequired]="true"> </dxi-item>
                <dxi-item dataField="password" [editorOptions]="{ mode: 'password' }" [isRequired]="true"> </dxi-item>
                <dxi-item [label]="{ text: ' ' }">
                    <div *dxTemplate>
                        <dx-button text="Login" type="default" validationGroup="loginData" (click)="login()"></dx-button>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </form>
</div>
